import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

export interface TemplateWorkOrderLot {
  description: string;
  id: string;
  lot_unit: string;
  lot_unit_id: string;
  template_description: string;
  template_work_order_id?: string;
}

interface TemplateWorkOrderLotState {
  templateWorkOrderLots: TemplateWorkOrderLot[];
  templateWorkOrderLot: TemplateWorkOrderLot | {};
}

const itemDetails = {
  pluralName: "template_work_order_lots",
  singularName: "template_work_order_lot",
};

const emptyTemplateWorkOrderLot: TemplateWorkOrderLot = {
  description: "",
  id: "",
  lot_unit: "",
  lot_unit_id: "",
  template_description: "",
  template_work_order_id: "",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    template_work_order_lot: {
      ...jsConn.formParams,
    },
  };
};

const state: TemplateWorkOrderLotState = {
  templateWorkOrderLots: [],
  templateWorkOrderLot: {},
};

const mutations = {
  LOAD_TEMPLATE_WORK_ORDER_LOTS(
    state: TemplateWorkOrderLotState,
    payload: TemplateWorkOrderLot[],
  ) {
    state.templateWorkOrderLots = payload;
  },
  LOAD_TEMPLATE_WORK_ORDER_LOT(
    state: TemplateWorkOrderLotState,
    payload: TemplateWorkOrderLot,
  ) {
    state.templateWorkOrderLot = payload;
  },
};

const actions = {
  needTemplateWorkOrderLots(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.getItems(jsConn, itemDetails).then(jsConn => {
      context.commit("LOAD_TEMPLATE_WORK_ORDER_LOTS", jsConn.response);
      return Promise.resolve(jsConn);
    });
  },
  needTemplateWorkOrderLot(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api.getItem(jsConn, itemDetails).then(jsConn => {
      context.commit("LOAD_TEMPLATE_WORK_ORDER_LOT", jsConn.response);
      return Promise.resolve(jsConn);
    });
  },
  createTemplateWorkOrderLot(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .createItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit("LOAD_TEMPLATE_WORK_ORDER_LOT", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
  updateTemplateWorkOrderLot(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .updateItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit("LOAD_TEMPLATE_WORK_ORDER_LOT", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
  deleteTemplateWorkOrderLot(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);

    return api
      .deleteItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit(
          "LOAD_TEMPLATE_WORK_ORDER_LOT",
          emptyTemplateWorkOrderLot,
        );
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  templateWorkOrderLots: (state: TemplateWorkOrderLotState) => {
    return state.templateWorkOrderLots;
  },
  templateWorkOrderLot: (state: TemplateWorkOrderLotState) => {
    return state.templateWorkOrderLot;
  },
  templateWorkOrderLotsForTable: (state: TemplateWorkOrderLotState) => {
    return state.templateWorkOrderLots;
  },
};

const templateWorkOrderLotsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default templateWorkOrderLotsModule;
